import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'localizedDate',
    pure: false,
    standalone: false
})
export class LocalizedDatePipe implements PipeTransform {

  constructor() {
  }

  transform(value: any, pattern: string = 'shortDate'): any {
    const datePipe: DatePipe = new DatePipe("de");
    if (!value) {
      return ' - ';
    } else if ("length" in value) {
      // Date is in array format
      value = new Date(value[0], value[1] - 1, value[2]);
    }
    return datePipe.transform(value, pattern);
  }

}
